module.exports = __webpack_public_path__ + "static/media/water.6b60f2bb.svg";